/**
 * Temporary FE mask when idle time exceeds total tracked time (bad stored data).
 * `totalTracked` and `idle` must use the same unit (seconds, minutes, or hours).
 * Remove usages of this module when the upstream bug is fixed.
 *
 * @param {number} totalTracked
 * @param {number} idle
 * @returns {{ displayIdle: number, idlePercent: number }}
 */
export function normalizeIdleForDisplay(totalTracked, idle) {
  const total = Number(totalTracked);
  const idleVal = Number(idle);
  const safeTotal = Number.isFinite(total) && total > 0 ? total : 0;
  const safeIdle = Number.isFinite(idleVal) && idleVal > 0 ? idleVal : 0;
  if (safeTotal <= 0) {
    return { displayIdle: 0, idlePercent: 0 };
  }
  const displayIdle = Math.min(safeIdle, safeTotal);
  const idlePercent = (displayIdle / safeTotal) * 100;
  return { displayIdle, idlePercent };
}

/**
 * @param {number} totalMinutes
 * @returns {{ hours: number, minutes: number }}
 */
export function minutesToHoursMinutes(totalMinutes) {
  const m = Math.max(0, Math.floor(Number(totalMinutes) || 0));
  return {
    hours: Math.floor(m / 60),
    minutes: m % 60,
  };
}
